commons.filter("sanitize", ($sce) => {
    return html => $sce.trustAsHtml(html);
});